const convert = (obj, prefix, result) =>
{
	result = result || (new FormData());
	
	// iterate over all properties
	for(var prop in obj)
	{
		if(obj.hasOwnProperty(prop))
		{
			var value = obj[prop];
			
			// build the property name for the result object
			// first level is without square brackets
			var name = prefix ? prefix + '[' + prop + ']' : prop;
			if(typeof value !== 'object' || value === null)
			{
				// not an object, add value to final result
				result.set(name, value);
			}
			else
			{
				// object, go deeper
				convert(value, name, result);
			}
		}
	}
	
	return result;
}

export default convert;